module.exports = __webpack_public_path__ + "img/fk-logo.5ff417c9.png";